import stemstart from '../assets/images/stemwerkz_start.png'
import stemmember from '../assets/images/stemwerkz_membership.png'
import classwerkz from "../assets/images/classwerkz.png";
import portal from "../assets/images/nodma_portal.png";
import classroom from "../assets/images/nodma_classroom.png";
import writer from "../assets/images/nodma_writer.png";

const ProjApi = [
    {
        image: stemstart,
        title: '1. Stemwerkz Start',
        body: 'This is the portal to the Stemwerkz apps, the online STEM education website. One of the sites that I built from scratch and still maintaining, using Angular.',
        link: 'https://start.stemwerkz.org/',
        tools: 'Angular10, Typescript, Html, Css, Bootstrap'
    },
    {
        image: stemmember,
        title: '2. Stemwerkz Membership',
        body: 'This was the previous portal to Stemwerkz apps which allows for managing the created player accounts. Another site that was built from scratch using Angular.',
        link: 'https://account.stemwerkz.org/',
        tools: 'Angular8, Typescript, Html, Css, Bootstrap'
    },
    {
        image: classwerkz,
        title: '3. Classwerkz',
        body: 'The class management system that allows for customers to check on their class and teachers to moderate the class. The first on-going project that I jumped right in after joining the team. Built with Angular.',
        link: 'http://classwerkz.brainlitz.net',
        tools: 'Angular5, Typescript, Html, Css, Bootstrap'
    },
    {
        image: portal,
        title: '4. Nodma Portal',
        body: 'Nodma is another application that allows for students and teachers to communicate and teach in real time. Nodma portal is the gateway to accessing different parts of the Nodma app. Portal is built using Angularjs.',
        link: 'https://nodma.pagewerkz.com/#/login',
        tools: 'Angularjs, Javascript, Html, Css'
    },
    {
        image: classroom,
        title: '5. Nodma Classroom',
        body: 'Classroom is where teachers can assign students to each class and allocate available books for each class. Classroom is built using Angular.',
        link: 'https://nodma.pagewerkz.com/classroom/dashboard',
        tools: 'Angular8, Typescript, Html, Css, Bootstrap'
    },
    {
        image: writer,
        title: '6. Nodma Writer',
        body: 'Teachers can create their own books or upload pdf in writer which can later be viewed by students in Reader. Writer is built with Angularjs.',
        link: 'https://nodma.pagewerkz.com/canvas/#/book',
        tools: 'Angularjs, Javascript, Html, Css'
    },

]
export default ProjApi